import StatusChip, { ChipType } from 'components/@extended/StatusChip';
import { useMemo } from 'react';
import { ClassifierData } from 'types/classifiers';
import { TimecardStatusType } from 'types/timecards';
import { getClassifierText } from 'utils/getTranslations';

export interface TimecardStatusLabelProps {
    statusCode: string;
    classifier: ClassifierData;
}

export const TimecardStatusLabel = ({ statusCode, classifier }: TimecardStatusLabelProps): JSX.Element => {
    const label = useMemo(() => getClassifierText(classifier, statusCode), [statusCode, classifier]);

    const statusChipType = useMemo<ChipType>(() => {
        switch (statusCode) {
            case TimecardStatusType.DRAFT:
                return 'outlined';
            case TimecardStatusType.FINISHED:
                return 'warning';
            default:
                return undefined;
        }
    }, [statusCode]);

    return <StatusChip type={statusChipType} label={label} />;
};
